import { render, staticRenderFns } from "./cashGift.vue?vue&type=template&id=0bf2c828&scoped=true"
import script from "./cashGift.vue?vue&type=script&lang=js"
export * from "./cashGift.vue?vue&type=script&lang=js"
import style0 from "./cashGift.vue?vue&type=style&index=0&id=0bf2c828&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf2c828",
  null
  
)

export default component.exports